import React from 'react';
import PropTypes from 'prop-types';
import EditableText from './EditableText';
import styles from './EditableCaption.css';

const EditableCaption = ({onSaveToStory, onSaveToStoryAndOriginal, ...props}) => {
    const saveToStoryAction = onSaveToStory ? {
        tooltip: 'save to story',
        iconClass: 'fa fa-check',
        callback: onSaveToStory,
    } : null;

    const saveToStoryAndOriginalAction = onSaveToStoryAndOriginal ? {
        tooltip: 'save to story and original',
        iconClass: styles.doubleCheckmark,
        callback: onSaveToStoryAndOriginal,
    } : null;

    return (
        <EditableText {...props}
            primaryAction={saveToStoryAction}
            secondaryAction={saveToStoryAndOriginalAction} />
    );
};

EditableCaption.propTypes = {
    defaultValue: PropTypes.string,
    onSaveToStory: PropTypes.func,
    onSaveToStoryAndOriginal: PropTypes.func,
};

export default EditableCaption;
